import React, { useState, useEffect, useMemo } from "react";
import { useUserAndGameContext } from "../../../contexts/UserAndGameContext";
import { useSuperPickemContext } from "../context/SuperPickemContext";
import { Typography, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import QuickPickGamesComing from "../../QuickPickGames/CardPieces/QuickPickGamesComing";
import { useSearchParams } from "react-router-dom";
import TabSelectionButtons from "../../GamePageComponents/TabSelectionButtons/TabSelectionButtons";
import DailyPickemPicks from "./DailyPickemPicks";
import GameStatsNew from "./GameStatsNew";
import ChampPicksNew from "./ChampPicksNew";
import { DateTime } from 'luxon';

const SuperPickemPoolPicksAgnostic = () => {
    const {
        masterPoolData,
        leaderboardData,
    } = useUserAndGameContext();

    const {
        intervalOptions,
    } = useSuperPickemContext();

    // const intervalOptions = [
    //     // "2025-04-10T00:00:00",
    //     // "2025-04-14T00:00:00",
    //     "2025-04-15T00:00:00",
    //     "2025-04-16T00:00:00",
    //     "2025-04-18T00:00:00",
    //     "2025-04-19T00:00:00"
    // ];

    const [searchParams, setSearchParams] = useSearchParams();
    const [selectedTab, setSelectedTab] = useState(null);

    const poolPicksModalInfo = masterPoolData?.modalInfo?.poolPicks;
    //console.log("poolPicksModalInfo", poolPicksModalInfo);
    const tabs = masterPoolData?.picksPageInfo?.tabs;

    // Handle tab selection
    useEffect (() => {
        if (!tabs?.length) return;

        const tabFromUrl = searchParams.get('tab');
        let targetTab;

        if (tabFromUrl && tabs.some(t => t.tab === tabFromUrl)) {
            targetTab = tabs.find(t => t.tab === tabFromUrl);
        } else {
            targetTab = tabs.find(t => t.default) || tabs[0];
            // Only update URL if current tab is different from target tab
            if (tabFromUrl !== targetTab.tab) {
                setSearchParams({ ...Object.fromEntries(searchParams), tab: targetTab.tab });
            }
        }

        setSelectedTab(targetTab.tab);
    }, [tabs, searchParams, setSearchParams]);

    // Filter dates function
    function filterDates(intervalOptions) {
        // Convert string dates to DateTime objects - preserving original strings for output
        const dateObjs = intervalOptions.map(dateStr => ({
            original: dateStr,
            date: DateTime.fromISO(dateStr)
        }));
        
        // Get today's date in New York timezone, at start of day
        const timeNowInNewYork = DateTime.now().setZone("America/New_York").startOf('day');
        //console.log("Time Now in New York:", timeNowInNewYork.toISO());
        
        // Filter dates that are today or in the past
        const todayOrPastDates = dateObjs.filter(item => 
            item.date <= timeNowInNewYork
        );
        
        // Sort future dates chronologically
        const futureDates = dateObjs.filter(item => 
            item.date > timeNowInNewYork
        ).sort((a, b) => a.date.toMillis() - b.date.toMillis());
        
        let result = [...todayOrPastDates];
        
        // Check if today's date is included in our filtered list
        const hasToday = todayOrPastDates.some(item => 
            item.date.hasSame(timeNowInNewYork, 'day')
        );
        
        // Handle special cases:
        if (result.length === 0) {
            // Case 1: If no past/present dates, add the first future date
            if (futureDates.length > 0) {
                result.push(futureDates[0]);
            }
        } else if (!hasToday) {
            // Case 2: Has past dates but no today, add the next future date
            if (futureDates.length > 0) {
                result.push(futureDates[0]);
            }
        }
        
        // Sort chronologically and return original string format
        return result
            .sort((a, b) => a.date.toMillis() - b.date.toMillis())
            .map(item => item.original);
    }

    // Get filtered dates and reverse them for display
    const filteredDates = filterDates(intervalOptions || []);
    const filteredDatesReverse = [...filteredDates].reverse();
    // console.log("Filtered Dates:", filteredDates);

    return (
        <>
            <TabSelectionButtons selectedTab={selectedTab} tabs={tabs} />
            {/* {poolPicksModalInfo && (
                <>
                    <QuickPickGamesComing
                        page={'pool-picks'}
                        title={poolPicksModalInfo?.title}
                        body={poolPicksModalInfo?.body}
                        quickPick={false}
                    />

                    <Box sx={{ marginBottom: '48px' }} /> 
                </>
            )} */}

            {selectedTab === 'daily-picks' && (
                <DailyPickemPicks 
                    filteredDatesReverse={filteredDatesReverse}
                />
            )}

            {selectedTab === 'game-stats' && (
                <GameStatsNew 
                    filteredDatesReverse={filteredDatesReverse}
                />
            )}

            {selectedTab === 'champ' && (
                <ChampPicksNew />
            )}
        </>
    );
};

export default SuperPickemPoolPicksAgnostic;